
import { SaleConfigCalendarToShowField } from "@/utils/sale-config-calendar-to-show-field";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import AppColumnSelect from "@/components/models/ColumnSelect.vue";
import { getModel, Model } from "@/utils/models/model";

export default Vue.extend({
	data(){
		return {
			val: new SaleConfigCalendarToShowField()
		};
	},
	props: {
		value: {
			type: Object as ()=>SaleConfigCalendarToShowField,
		},
		isNew: Boolean
	},
	computed: {
		title():TranslateResult{
			if (this.isNew){
				return this.$ct("add-new-calendar-field");
			}
			return this.$ct("edit-calendar-field");
		},
		model():Model{
			return getModel("Sale");
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				if (!this.value) return;
				this.val = new SaleConfigCalendarToShowField(this.value.getJSON());
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			this.$emit("input", this.val);
			this.close();
		}
	},
	components: {
		AppColumnSelect
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
